import React from "react";
import "./FilterModal.css";

const FilterModal = ({ options, visible, defaultOption, setFilter }) => {
  return (
    <>
      <div
        className={`Modal-background filter ${visible}`}
        onClick={() => {
          setFilter("hidden");
        }}
      ></div>
      <div
        className={`filter-modal-container ${visible}`}
        onClick={() => {
          setFilter("hidden");
        }}
      >
        <div
          className={`filter-modal ${visible}`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <ul
            className="filter-options"
          >
            {defaultOption}
            {options}
          </ul>
        </div>
        <div className="oneHundredPx"></div>
        <div className="oneHundredPx"></div>
      </div>
    </>
  );
};

export default FilterModal;
